<script>
  import { mapGetters } from 'vuex'
  import ServiceIconMixin from '@/components/parts/mixins/ServiceIconMixin'
  import InputMixin from './InputMixin'

  export default {
    mixins: [ServiceIconMixin, InputMixin],
    props: {
      modelValue: {
        type: Array,
        default () {
          return []
        }
      },
      label: {
        type: String,
        default: ''
      },
      getItemsApi: {
        type: String,
        default: ''
      },
      items: {
        type: Array,
        default () {
          return []
        }
      },
      itemText: {
        type: String,
        default: ''
      },
      itemTextTranslateKey: {
        type: String,
        default: ''
      },
      itemValue: {
        type: String,
        default: ''
      },
      iconFileKey: {
        type: String,
        default: ''
      },
      subTitleKey: {
        type: String,
        default: ''
      },
      designLabel: Boolean,
      single: Boolean,
      ifPrimaryColorId: {
        type: String,
        default: ''
      },
      loading: Boolean
    },
    emits: ['update:modelValue'],
    data: () => ({
      dataItems: [],
      dataLoading: false,
      model: []
    }),
    computed: {
      ...mapGetters(['ui'])
    },
    watch: {
      modelValue () {
        this.model = this.modelValue
      },
      model () {
        this.$emit('update:modelValue', this.model)
      },
      items () {
        this.dataItems = this.items
      }
    },
    created () {
      if (this.getItemsApi) {
        this.getItems()
      } else {
        this.dataItems = this.items
      }
      this.model = this.modelValue
    },
    methods: {
      getItems () {
        this.dataLoading = true
        if (this.dataItems.length === 0 && this.getItemsApi) {
          this.$http.get(this.getItemsApi, { params: { limit: 1000 } }).then((res) => {
            this.dataItems = res.data.results
            this.dataLoading = false
          })
        }
      },
      getItemText (itemText) {
        if (this.itemTextTranslateKey) {
          return this.$t(this.itemTextTranslateKey + '.' + itemText)
        } else {
          return itemText
        }
      },
      remove (item) {
        const index = this.model.indexOf(item[this.itemValue])
        if (index >= 0) this.model.splice(index, 1)
      },
      isSelected (id) {
        return this.model.indexOf(id) >= 0
      },
      chipColor (id) {
        if (this.ifPrimaryColorId) {
          return 'primary'
        } else {
          return null
        }
      }
    }
  }
</script>
